import React, { Fragment, useState } from 'react';
import { translate } from 'react-i18next';

import AsideMenu from '../common/asideMenu';

const SignedOutHeader = ({ t }) => {
  const [openSideBar, setOpenSideBar] = useState(false);

  return (
    <Fragment>
      <header className="signedOutHeader">
        <div className="signedOutHeader__banner">
          <img
            src="https://cdn.selflystore.com/images-general/logos/selfly-logo.svg"
            alt="logo"
          />
          <div className="signedOutHeader__banner-title">{t('refill_app')}</div>
        </div>
        <div
          className="signedOutHeader__menu"
          onClick={() => setOpenSideBar(true)}
        >
          <span />
          <span />
          <span />
        </div>
      </header>
      <AsideMenu
        openSideBar={openSideBar}
        closeSideBar={setOpenSideBar}
        t={t}
      />
    </Fragment>
  );
};

export default translate('common')(SignedOutHeader);
